export default __webpack_public_path__ + "assets/img/archive-ex-img.png";